import axios from "axios";
import { PARTNER_TOKEN_KEY } from "@/lib/partnerApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/docs`;

const client = (auth) => {
  const cfg = (extra = {}) => { const a = auth(); return { headers: a.headers, params: { ...a.params, ...extra.params }, ...(extra.blob ? { responseType: "blob" } : {}) }; };
  return {
    get: (p, params) => axios.get(`${BASE}${p}`, cfg({ params })).then((r) => r.data),
    post: (p, body) => axios.post(`${BASE}${p}`, body, cfg()).then((r) => r.data),
    patch: (p, body) => axios.patch(`${BASE}${p}`, body, cfg()).then((r) => r.data),
    put: (p, body) => axios.put(`${BASE}${p}`, body, cfg()).then((r) => r.data),
    del: (p) => axios.delete(`${BASE}${p}`, cfg()).then((r) => r.data),
    blobUrl: (p) => axios.get(`${BASE}${p}`, cfg({ blob: true })).then((r) => URL.createObjectURL(r.data)),
    /** Saves the PDF to the device (no new tab). */
    download: (p, name) => axios.get(`${BASE}${p}`, cfg({ blob: true })).then((r) => {
      const u = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(u), 60000);
    }),
    /** Opens the tab inside the click (so popup blockers allow it), then loads the PDF into it. */
    openPdf: (p) => {
      const w = window.open("", "_blank");
      return axios.get(`${BASE}${p}`, cfg({ blob: true })).then((r) => { const u = URL.createObjectURL(r.data); if (w) w.location.href = u; else window.location.assign(u); setTimeout(() => URL.revokeObjectURL(u), 60000); })
        .catch((e) => { w?.close(); throw e; });
    },
  };
};
const bearer = (key) => () => { const t = localStorage.getItem(key); return { headers: t ? { Authorization: `Bearer ${t}` } : {}, params: {} }; };

/** Staff (admin site). */
export const docsApi = client(bearer("nex_token"));
export const partnerDocsApi = client(bearer(PARTNER_TOKEN_KEY));
export const vendorDocsApi = client(bearer("tea_vendor_token"));
const residentCache = {};
export const residentDocsApi = (token) => (residentCache[token] ||= client(() => ({ headers: {}, params: { token } })));
export const docsErr = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join("; ") : "Something went wrong. Try again.";
};
export const AUD_LABEL = { resident: "Residents", staff: "Staff", partner: "Partners", contract_vendor: "Contract Vendor agreements" };
